import * as S from './styles';
import { Collapse as AntdCollapse } from 'antd';
import { ReactNode } from 'react';

const { Panel } = AntdCollapse;

export type CollapseProps = {
  title: string;
  children?: ReactNode;
  variant?: 'primary' | 'secondary';
};

const Collapse = ({ title, children, variant = 'primary' }: CollapseProps) => (
  <S.Wrapper variant={variant}>
    <AntdCollapse bordered={false}>
      <Panel key="1" header={title}>
        {children}
      </Panel>
    </AntdCollapse>
  </S.Wrapper>
);

export default Collapse;
